import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class ItemHierarchyManagerService {
  environment = EnvironmentService.environment;

  constructor(private http: HttpClient) { }

  GetItemHierarchyList(): Observable<any> {
    return this.http.get<any>(`${this.environment.ItemHierarchyManager}/productHierarchyGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }
  GetProductHierarchyList(): Observable<any> {
    return this.http.get<any>(`${this.environment.HierarchyManager}/productHierarchyMetadataGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AddUpdateItemHierarchyList(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ItemHierarchyManager}/productHierarchyInsertOrUpdate`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ImportItemHierarchyManagerList(body: any) {
    return this.http.post(`${this.environment.ItemHierarchyManager}/productsHierarchyImport`, body)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  DeleteItemHierarchyRow(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ItemHierarchyManager}/productHierarchyDelete`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }


}
